module.exports = __webpack_public_path__ + "static/media/list-icon.a6ee028e.svg";